import { render } from "./SwitchInput.vue?vue&type=template&id=147df380"
import script from "./SwitchInput.vue?vue&type=script&lang=js"
export * from "./SwitchInput.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__